import { AlertService } from '../../service/alert/alert.service';
import { FavoriteService } from 'src/app/air/modules/common/service/favorite/favorite.service';
import { ViewChild, Component, EventEmitter, Input, OnInit, Output, AfterViewInit, OnDestroy, HostListener, Renderer2 } from "@angular/core";
import moment from 'moment';
import { IFiltersCriteria, ISelectedFilters } from "src/app/air/modules/common/lib/types/selectedFilters";
import { CommonService, FilterService, NavigationService, ShipmentService, StorageService, TrackingService } from "src/app/air/modules/common/service";
import { SubSink } from "subsink";
import { TableService } from "src/app/air/modules/common/service/table/table.service";
import { OverlayPanel } from 'primeng/overlaypanel';
import { AirAppRoutes } from "src/app/air/modules/common/lib/air-api-constant";
import { Console } from 'console';
import { MessageService } from 'primeng/api';
import { async, map } from 'rxjs';
import { PortalProfileService } from '../../service/portal-profile/portal-profile.service';

@Component({
    selector: "app-common-table",
    templateUrl: "./common-table.component.html",
    styleUrls: ["./common-table.component.scss"],
    standalone: false
})
export class CommonTableComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('dt', { static: false }) dataTable: any;
    @ViewChild('columnSettingsDropdown', { static: false }) columnSettingsDropdown: any;
    @ViewChild('event') eventsPanel: OverlayPanel;
    @Output() showDetails = new EventEmitter();
    @Output() removeData = new EventEmitter();
    @Output() refreshTable = new EventEmitter();
    @Output() addData = new EventEmitter();
    @Input() view: string = "";
    @Input() shipmentList: Array<any> = [];
    @Input() selectedIndex: number;
    @Input() emptyTableMessage: string = '';
    @Input() isTrackingList: string;
    routeType: string = null;
    timelinePanelData: any = {};
    timelineTextMargin: any;
    userSavedColumnSeq: any = null;
    userSavedColumnSeqRequest: any = {};
    userSavedColumn: any[];
    isColSeqAlreadySaved: boolean = true;
    exportVisibility: boolean;
    selectedGlobalFilter: any;
    downloadOptionDisabled: boolean = false;
    assignment: any = {};
    @Input() get selectedColumns(): any[] {
        return this._selectedColumns;
    }

    drayageSelectionType: string = "single";

    stepsWidth: string;

    selectedDrageManager: any = {};

    _selectedColumns: any[];

    tabDetails: string;

    graphId: string = "";

    exportColumns = [];

    selectedData: any = [];

    assignDrayageSelection: boolean = false;

    loading: boolean = false;

    stepsItems: Array<any> = [];

    keyRef: any;

    disableOnHideComments: boolean = true;

    showCustomRank: boolean = false;
    fileDisable: boolean = false;
    customRank: number = null;
    private subscription = new SubSink();

    filter: any;
    tableHeaders: Array<any> = [];
    searchValue: string = '';

    tableSettings: any = {
        rowsPerPage: 10,
        rowsPerPageOptions: [10, 25, 50],
        firstAtPage: 0,
        showJumpToPageDropdown: false,
        stateKey: ''
    }
    noDataText: string = 'Loading...';
    noDocument: string = 'Loding...';
    showExport: boolean = false;
    startDateActive = false;
    endDateActive = false;
    startDate: string = null;
    endDate: string = null;
    startDateInput: string = "";
    endDateInput: string = "";
    customPeriodListVisibility: boolean = false;
    shipmentType: any;
    downloadToolTipMesssage: string = "";
    downloadInfoMessage: string = "";
    // "For Non-Started, Pre-Carriage, In-Transit and All shipments the data would be downloaded based on estimated departure date and for Arrival and Post Carriage shipments data would be downloaded based on estimated arrival date. Max data available in the email is limited to 50,000 entries.";
    public downloadList: any = [
        { key: 1, value: "Last 30 days", },
        { key: 3, value: "Last 3 months", },
        { key: 6, value: "Last 6 months", },
        { key: 12, value: "Last 12 months", },
        { key: 0, value: "Custom Period", }
    ];

    set selectedColumns(val: any[]) {
        let cols = this.tableHeaders.filter((col) =>
            val.includes(col)
        );
        let orderedCols = this.getColumnOrder();
        if (orderedCols) {
            cols.forEach((item, index) => { if (!orderedCols.includes(item.field)) { orderedCols.splice(index, 0, item.field) } })
            let columns = this.commonService.mapOrder(cols, orderedCols, 'field')
            this._selectedColumns = columns.map((col) => {
                return this.tableHeaders.find(e => e.field == col.field)
            });
        }
        else if (this.userSavedColumn) {
            this._selectedColumns = this.userSavedColumn;
        }
        else {
            this._selectedColumns = cols;
        }
    }

    @HostListener('window:click', ['$event'])
    handleKeyDown(event: any) {
        const exportElem = document.getElementById('exportList');
        const exportElemIcon = document.getElementById('exportIcon');
        if (exportElem) {
            if (exportElem.contains(event.target) || (exportElemIcon && exportElemIcon.contains(event.target))) {
                // Clicked in box
            } else {
                this.exportVisibility = false;
            }
        }
    }

    constructor(
        public renderer: Renderer2,
        protected commonService: CommonService,
        protected shipmentService: ShipmentService,
        protected trackingService: TrackingService,
        protected filterService: FilterService,
        protected tableService: TableService,
        private favoriteService: FavoriteService,
        private alertService: AlertService,
        private storageService: StorageService,
        private navigationService: NavigationService,
        private messageService: MessageService,
        private portalProfileService: PortalProfileService
    ) {
        const tableHeader = this.tableService.getHeaders();
        this.storageService.setItem('AirtrackingColumnSettings', tableHeader);
        window.addEventListener('beforeunload', this.handleBeforeUnload.bind(this));

        this.renderer.listen('body', 'click', () => {
            if (this.showExport) {
                this.showExport = false;
            }
        });
        this.navigationService.$currentNav.subscribe(currentRoute => {
            if (currentRoute) {
                switch (currentRoute.routeType) {
                    case AirAppRoutes.User.TRACKING_LIST: {
                        this.routeType = currentRoute.routeType;
                        this.tableHeaders = this.storageService.getItem('AirtrackingColumnSettings')
                        this.tableSettings.stateKey = 'AirtrackingListState';
                        break;
                    }
                    case AirAppRoutes.User.FAVORITE: {
                        this.routeType = currentRoute.routeType;
                        this.tableHeaders = this.storageService.getItem('favoriteColumnSettings')
                        this.tableSettings.stateKey = 'favoriteTableState';
                        break;
                    }
                    case AirAppRoutes.Manager.EXCEPTION: {
                        this.routeType = currentRoute.routeType;
                        this.tableHeaders = this.storageService.getItem('exceptionColumnSettings');
                        this.tableSettings.stateKey = 'exceptionTableState';
                        break;
                    }
                    // case AirAppRoutes.Manager.TPL_EXCEPTION_MANAGER: {
                    //     this.routeType = currentRoute.routeType;
                    //     this.tableHeaders = this.storageService.getItem('exception3plColumnSettings');
                    //     this.tableSettings.stateKey = 'exception3plTableState';
                    //     break;
                    // }
                    default:
                        this.routeType = AirAppRoutes.User.TRACKING_LIST;
                }
                // console.log(this.tableHeaders);
                // this.selectedColumns = this.tableHeaders.filter((header: any) => { return header.isDefault; });
            }
        })
        this.subscription.add(
            this.filterService.$filterSelection.subscribe(filter => {
                const filterSelected: IFiltersCriteria = this.filterService.getIds(
                    filter
                );
                this.selectedGlobalFilter = filterSelected;
                if (!Array.isArray(filterSelected.companies))
                    this.selectedGlobalFilter.companies = [filterSelected.companies];
                else {
                    this.selectedGlobalFilter.companies = filterSelected.companies;
                }
            }),
        );
        this.subscription.add(
            this.filterService.$keyRef.subscribe((keyRef) => {
                this.keyRef = keyRef;
            })
        );
        this.shipmentService.$shipmentTypeSubject.subscribe((shipmentType) => {
            this.selectedGlobalFilter.shipmentType = shipmentType;
            this.shipmentType = shipmentType;
            if (shipmentType === 5 || shipmentType == null) {
                this.downloadOptionDisabled = true;
                this.downloadToolTipMesssage = "For In-active and Live track pending, Download option is disabled."
            }
            else {
                // this.downloadToolTipMesssage = ""
                this.downloadOptionDisabled = false;
            }
        })
        this.selectedData = JSON.parse(JSON.stringify(this.shipmentList));
        this.stepsItems = [];
        this.timelinePanelData.headerText = "";
    }

    ngOnInit(): void {
        this.selectedData = JSON.parse(JSON.stringify(this.shipmentList));

        if (this.view == 'tracking') {
            this.getSavedColumnSequence();
        }
        else {
            this.selectedColumns = this.tableHeaders.filter((header: any) => { return header.isDefault; });
        }
    }

    private handleBeforeUnload(event: BeforeUnloadEvent): void {
        // Perform any necessary actions before the page unloads
        // For example, save data or show a confirmation message
        this.saveTableState();
    }

    tableRefresh() {
        // this.saveTableState();
    }

    saveTableState() {
        if (this.isColSeqAlreadySaved === false)
            this.storageService.setItem('AirtrackingListChangedState', this.storageService.getItem('AirtrackingListState'));
        else
            this.storageService.setItem('AirtrackingListChangedState', null);
    }

    private getSavedColumnSequence() {
        let body = {
            "pageType": "tracking-list",
            "columnSeqJson": "",
            "userId": this.storageService.getItem("email"),

        }
        this.portalProfileService.getUserSavedColumnSequence(body).subscribe(
            {
                next: (result: any) => {
                    if (!result) {
                        return;
                    }
                    this.userSavedColumnSeq = JSON.parse(result.data.columnSeqJson);
                    if (this.userSavedColumnSeq) {
                        // Get all columns present in the API sequence
                        const columnsFromAPI = Object.keys(this.userSavedColumnSeq).map(field => {
                            return this.tableHeaders.find(header => header.field === field);
                        }).filter(column => column !== undefined);

                        // Sort the columns from API based on the sequence
                        const sortedColumnsFromAPI = columnsFromAPI.sort(
                            (a, b) => this.userSavedColumnSeq[a.field] - this.userSavedColumnSeq[b.field]
                        );

                        // Concatenate the sorted columns from API with the remaining columns
                        this.userSavedColumn = sortedColumnsFromAPI;
                        this.restoreTableState(this.userSavedColumn);
                    }
                    else {
                        this.selectedColumns = this.tableHeaders.filter((header: any) => { return header.isDefault; });
                    }

                },
                complete: () => {
                    // Handle completion if needed
                    this.selectedColumns = this.tableHeaders.filter((header: any) => { return header.isDefault; });
                },
                error: (error) => {
                    console.error('Error fetching user saved column sequence:', error);
                    this.selectedColumns = this.tableHeaders.filter((header: any) => { return header.isDefault; });
                },

            }

        );
    }

    async restoreTableState(userSavedColumn: any) {
        const storedState = this.storageService.getItem('AirtrackingListChangedState');
        if (storedState) {
            // Apply the stored table state to your table component
            this.userSavedColumn = await Promise.resolve(
                this.tableHeaders.filter((header: any) => storedState.columnOrder.includes(header.field))
                    .sort((a, b) => storedState.columnOrder.indexOf(a.field) - storedState.columnOrder.indexOf(b.field))
            );

            // Now assign the value to this.selectedColumns
            this.selectedColumns = this.userSavedColumn;
            this.onTrackingListColumnreOrder(storedState);
            this.isColSeqAlreadySaved = false;
        }

        else {
            this.selectedColumns = userSavedColumn;
        }
    }

    saveFavorites(shipment: any) {
        shipment.tComments = shipment.tComments.trim();
        if (shipment.tComments.length < 3) {
            shipment.hasComment = false;
        } else {
            shipment.hasComment = true;
            this.favoriteService.setFavoriteShipment({
                "shipmentId": shipment.shipmentId,
                "comments": shipment.tComments,
            }).subscribe((response) => {
                shipment.comments = shipment.tComments;
            });
        }
        this.disableOnHideComments = false;
    }


    cancelFavoritesComments(shipment: any) {
        if (shipment.tComments)
            shipment.tComments = '';
    }

    onCommentsPanelHide(shipment: any) {
        if (this.disableOnHideComments) {
            if (shipment.comments == "" && shipment.tComments != "") {
                this.cancelFavoritesComments(shipment);
            }
            else if (shipment.comments != shipment.tComments) {
                shipment.tComments = shipment.comments;
            }
        }
        this.disableOnHideComments = true;
    }

    updateAlert(shipment) {
        if (!shipment.alert) {
            // this.alertService.setAlertShipment({ "shipmentId": shipment.shipmentId }).subscribe(res => {
            // });
            shipment.alert = !shipment.alert;
        }
        else {
            // this.alertService.removeAlertShipment({ "shipmentId": shipment.shipmentId }).subscribe(res => {
            // });
            shipment.alert = !shipment.alert;
        }
    }

    formatPurchaseOrderNumbersForDisplay(purchaseOrderNumberConcat: string): string {
        if (!purchaseOrderNumberConcat || purchaseOrderNumberConcat.trim().length === 0) {
            return '';
        }
        const purchaseOrderNumbersArray = purchaseOrderNumberConcat.split(',').map(num => num.trim());
        if (purchaseOrderNumbersArray.length <= 2) {
            return purchaseOrderNumbersArray.join(', ');
        } else {
            const firstTwo = purchaseOrderNumbersArray.slice(0, 2);
            return `${firstTwo.join(', ')}`;
        }
    }

    formatPurchaseOrderNumbersForTooltip(purchaseOrderNumberConcat: string): string {
        if (!purchaseOrderNumberConcat || purchaseOrderNumberConcat.trim().length === 0) {
            return '';
        }
        const purchaseOrderNumbersArray = purchaseOrderNumberConcat.split(',').map(num => num.trim());
        return purchaseOrderNumbersArray.join('\n');
    }

    hasMorePurchaseOrderNumbers(purchaseOrderNumberConcat: string): boolean {
        if (!purchaseOrderNumberConcat || purchaseOrderNumberConcat.trim().length === 0) {
            return false;
        }
        const purchaseOrderNumbersArray = purchaseOrderNumberConcat.split(',').map(num => num.trim());
        return purchaseOrderNumbersArray.length > 2;
    }

    onColumnSeqSaved() {
        if (!this.isColSeqAlreadySaved) {
            this.portalProfileService.setUserSavedColumnSequence("tracking-list", this.userSavedColumnSeqRequest).subscribe((result: any) => {
                if (result && result.message) {
                    this.messageService.add({
                        key: 'emptyToster',
                        severity: 'success',
                        summary: 'Success Message',
                        life: 10000,
                        detail: 'The Column Sequence has been reset'
                    });
                    this.isColSeqAlreadySaved = true;
                    this.userSavedColumnSeqRequest = null;
                    this.storageService.setItem('AirtrackingListChangedState', null);
                }
            })
        }
    }

    onTrackingListColumnreOrder(event) {
        if (event) {
            this.userSavedColumnSeqRequest = {};
            // Assign ascending numbers to field values
            if (event.columns) {
                event.columns.forEach((item, index) => {
                    this.userSavedColumnSeqRequest[item.field] = index;
                });
            }
            else if (event.columnOrder) {
                event.columnOrder.forEach((item, index) => {
                    this.userSavedColumnSeqRequest[item] = index;
                });
            }
            this.userSavedColumnSeqRequest = JSON.stringify(this.userSavedColumnSeqRequest);
            // console.log(this.userSavedColumnSeqRequest);
            this.isColSeqAlreadySaved = false;
        }
    }
    tableFilterCalled(event: any) {
        const hasFilters = Object.values(event.filters).some((filterObj: any) => {
            if (Array.isArray(filterObj)) {
                return filterObj.some(obj => obj.value !== null);
            } else {
                return filterObj.value !== null;
            }
        });
        if (hasFilters) {
            this.downloadOptionDisabled = true;
            this.downloadToolTipMesssage = "Clear the filter to enable download."
        }
        else {
            if (this.shipmentType == 5 || this.shipmentType == null) {
                this.downloadOptionDisabled = true;
            }
            else {
                this.downloadOptionDisabled = false;
                // this.downloadToolTipMesssage = "";
            }
        }
    }






    formatShipperReferenceNumbersForDisplay(shipperReferenceNumberConcat: string): string {
        if (!shipperReferenceNumberConcat || shipperReferenceNumberConcat.trim().length === 0) {
            return '';
        }
        const shipperReferenceNumbersArray = shipperReferenceNumberConcat.split(',').map(num => num.trim());
        if (shipperReferenceNumbersArray.length <= 2) {
            return shipperReferenceNumbersArray.join(', ');
        } else {
            const firstTwo = shipperReferenceNumbersArray.slice(0, 2);
            return `${firstTwo.join(', ')}`;
        }
    }

    formatShipperReferenceNumbersForTooltip(shipperReferenceNumberConcat: string): string {
        if (!shipperReferenceNumberConcat || shipperReferenceNumberConcat.trim().length === 0) {
            return '';
        }
        const shipperReferenceNumbersArray = shipperReferenceNumberConcat.split(',').map(num => num.trim());
        return shipperReferenceNumbersArray.join('\n');
    }

    hasMoreShipperReferences(shipperReferenceNumberConcat: string): boolean {
        if (!shipperReferenceNumberConcat || shipperReferenceNumberConcat.trim().length === 0) {
            return false;
        }
        const shipperReferenceNumbersArray = shipperReferenceNumberConcat.split(',').map(num => num.trim());
        return shipperReferenceNumbersArray.length > 2;
    }

    ngAfterViewInit() {
        switch (this.view) {
            case "home": {
                break;
            }
            case "tracking": {
                break;
            }
            case "favourite": {
                break;
            }
            case "trackingDetails": {
                break;
            }
        }
        this.subscription.add(
            this.tableService.$tableRefresh.subscribe((data: any) => {
                if (data) {
                    this.dataTable.reset();
                }
            })
        );
        this.dataTable.filterGlobal('', 'contains')
    }



    getTooltipText(assignment: any): string {
        if (assignment.source === 'CSV') {
            return 'Alerts are disabled as this shipment is uploaded via CSV';
        }
        if (assignment.shipmentStatus === 3) {
            return 'Alerts are disabled for document only shipment';
        }
        return 'Alerts cannot be set for Arrived, Inactive and Live Track Pending Shipments';
    }

    isTooltipDisabled(assignment: any): boolean {
        return !(
            (assignment.portOfArrivalActualDate !== null &&
                assignment.portOfDepartureActualDate !== null) ||
            (assignment.alert && assignment.isBulkSubscribed) ||
            assignment.logisticStatus === 'Inactive' ||
            assignment.source === 'CSV' ||
            assignment.shipmentStatus === 3
        );
    }

    getInitialSwitchValue(assignment: any): boolean {
        return assignment.alert && assignment.isBulkSubscribed
            ? true
            : assignment.alert && !assignment.isBulkSubscribed
                ? true
                : false;
    }

    getSwitchClasses(assignment: any): { [key: string]: boolean } {
        return {
            'csr-subscribed': assignment.alert && assignment.isBulkSubscribed,
            'csr-not-subscribed': assignment.alert && !assignment.isBulkSubscribed,
        };
    }

    isSwitchDisabled(assignment: any): boolean {
        return (
            assignment.source === 'CSV' ||
            (assignment.portOfArrivalActualDate !== null &&
                assignment.portOfDepartureActualDate !== null) ||
            (assignment.alert && assignment.isBulkSubscribed) ||
            assignment.logisticStatus === 'Inactive' ||
            assignment.shipmentStatus === 3
        );
    }

    //#region  Download Tracking List code

    checkDateRange() {
        if (this.startDate && this.endDate) {
            const currentDate = moment().utc().format('YYYY-MM-DD');
            const oneYearFromNow = moment().utc().add(1, 'years').format('YYYY-MM-DD');
            if (moment(this.endDate).isAfter(currentDate)) {
                this.messageService.add({
                    key: 'emptyToster',
                    severity: 'error',
                    summary: 'Error Message',
                    life: 10000,
                    detail: 'End date cannot be greater than the current date.'
                });
                return false;
            }

            if (moment(this.startDate).isAfter(oneYearFromNow)) {
                this.messageService.add({
                    key: 'emptyToster',
                    severity: 'error',
                    summary: 'Error Message',
                    life: 10000,
                    detail: 'Start date cannot be greater than one year from the current date.'
                });
                return false;
            }

            return true;
        } else {
            this.messageService.add({
                key: 'emptyToster',
                severity: 'error',
                summary: 'Error Message',
                life: 10000,
                detail: 'Please select start date and end date.'
            });
            return false;
        }
    }
    // it shows the first two followed by an ellipsis (...)
    formatContainerNumbersForDisplay(containerNumber: string): string {
        if (!containerNumber || containerNumber.trim().length === 0) {
            return '';
        }
        const containerNumbersArray = containerNumber.split(',').map(num => num.trim());
        if (containerNumbersArray.length <= 2) {
            return containerNumbersArray.join(', ');
        } else {
            const firstTwo = containerNumbersArray.slice(0, 2);
            return `${firstTwo.join(', ')}`;
        }
    }
    //formats the container numbers for display in the tooltip, with each number on a new line
    formatContainerNumbersForTooltip(containerNumber: string): string {
        if (!containerNumber || containerNumber.trim().length === 0) {
            return '';
        }
        const containerNumbersArray = containerNumber.split(',').map(num => num.trim());
        return containerNumbersArray.join('\n');
    }
    //  if there are more than two container numbers. it returns true, which triggers the display
    hasMoreContainers(containerNumber: string): boolean {
        if (!containerNumber || containerNumber.trim().length === 0) {
            return false;
        }
        const containerNumbersArray = containerNumber.split(',').map(num => num.trim());
        return containerNumbersArray.length > 2;
    }

    downloadTrackingList() {
        if (this.checkDateRange()) {
            this.customPeriodListVisibility = false;
            let body = {
                globalFilter: this.selectedGlobalFilter,
                startDate: this.startDate,
                endDate: this.endDate,
                pageSize: 10,
                pageNumber: 1,
                shipmentIds: [],
                shipmentType: this.selectedGlobalFilter.shipmentType,
            }
            this.shipmentService.getTrackingListDownload(body).subscribe((response) => {
                if (response) {
                    this.messageService.add({
                        key: 'emptyToster',
                        severity: 'success',
                        summary: 'Success Message',
                        life: 10000,
                        detail: 'The csv would be shared in the user mail id atleast after 10 mins'
                    });
                    this.cancelClicked();
                }
            })
        }
        else {
            this.customPeriodListVisibility = true;
        }

    }

    openExport(event: MouseEvent) {
        this.showExport = !this.showExport;
        event.preventDefault();
        event.stopPropagation();
        return;
    }
    customPeriodSelected(item) {
        if (item) {
            switch (item.key) {
                case 0: {
                    this.customPeriodListVisibility = true;
                    break;
                }
                // For 12 months 
                case 12: {
                    this.exportVisibility = false;
                    this.customPeriodListVisibility = false;
                    this.endDate = this.commonService.getCurrentDateTime();
                    this.startDate = this.commonService.getDateAfterDays(365);
                    this.downloadTrackingList();
                    break;
                }
                default: {
                    this.exportVisibility = false;
                    this.customPeriodListVisibility = false;
                    this.endDate = this.commonService.getCurrentDateTime();
                    this.startDate = this.commonService.getMonthDifferenceWithTime(item.key);
                    this.downloadTrackingList();
                    break;
                }
            }
        }
    }

    selectedDate(event) {
        if ((this.startDate && this.endDate) || (!this.startDate && !this.endDate)) {
            if (event.startDate) {
                this.startDateActive = true;
                this.endDateActive = false;
                this.startDateInput = moment(event.startDate.$d).format('YYYY-MM-DD');
                this.startDate = moment(event.startDate.$d).utc().format('YYYY-MM-DD');
                this.endDate = "";
            }
        }
        if (event.endDate) {
            this.startDateActive = false;
            this.endDateActive = true;
            this.endDateInput = moment(event.endDate.$d).format('YYYY-MM-DD');
            this.endDate = moment(event.endDate.$d).utc().format('YYYY-MM-DD');
        }
    }

    cancelClicked() {
        this.startDate = null;
        this.endDate = null;
        this.startDateInput = "";
        this.endDateInput = "";
        this.startDateActive = false;
        this.endDateActive = false;
        this.customPeriodListVisibility = false;
    }

    datesUpdated(ev) {
        this.downloadTrackingList();
    }

    //#endregion Download Tracking List end

    getTimeLineDetails(assignment, event) {
        this.eventsPanel.hide();
        this.noDataText = 'Loading...';
        this.stepsItems = []
        this.timelinePanelData = assignment;
        this.timelinePanelData.headerText = (assignment[this.keyRef.key]) && (assignment[this.keyRef.key].toLowerCase() != "n/a") ? this.keyRef.label + assignment[this.keyRef.key] : 'Forwarder Ref No. ' + assignment.bdpReferenceNumber
        this.subscription.add(
            this.trackingService.getTimeLineDetails(assignment.id).subscribe(res => {
                if (res) {
                    this.stepsItems = res.data.timeLineResponses;
                    const allowEvents: Array<any> = ['REC', 'ETAL', 'DEP', 'DEP', 'ETAX', 'ARR', 'ARR', 'DELC'];
                    const actual = ['REC', 'DEP', 'ARRT', 'ARR']
                    const estimate = ['ETAL', 'ETAT', 'DEPT', 'ETAX']

                    let hasActualPOD = false;
                    let hasActualPOA = false;
                    this.stepsItems = this.stepsItems.filter((item) => {
                        if ((assignment.scheduleStatus).includes('On Time'))
                            item.color = "blue"
                        else if ((assignment.scheduleStatus).includes('Late'))
                            item.color = "orange"
                        else if ((assignment.scheduleStatus).includes('Early'))
                            item.color = "green"
                        item.date = moment(item.date, 'YYYY-MM-DD').format('D MMM. YYYY');
                        if (item.eventCode == 'ARR') {
                            hasActualPOA = true;
                        }
                        if (item.eventCode == 'DEP') {
                            hasActualPOD = true;
                        }
                        return true;
                        // if (allowEvents.indexOf(item.eventCode) >= 0) {
                        // } else {
                        //     return false;
                        // }
                    });
                    let arrvCount = 1;
                    let deprtCount = 1;
                    this.stepsItems = this.stepsItems.map((item) => {
                        item.isActual = false;
                        item.isEstimate = false;

                        if (actual.indexOf(item.eventCode) >= 0)
                            item.isActual = true;
                        else if (estimate.indexOf(item.eventCode) >= 0)
                            item.isEstimate = true;

                        switch (item.event) {
                            case 'Transship Arrival':
                                item.event = `Transship ${arrvCount++} Arrival`
                                break;
                            case 'Transship Departure':
                                item.event = `Transship ${deprtCount++} Departure`
                                break;
                        }
                        return item;

                    });
                    // this.stepsItems = this.stepsItems.filter((item) => {
                    //     if (item.eventCode == 'ETAL' && hasActualPOD) {
                    //         return false;
                    //     }
                    //     if (item.eventCode == 'ETAX' && hasActualPOA) {
                    //         return false;
                    //     }
                    //     return true;
                    // });
                }
                this.stepsWidth = `${100 / (this.stepsItems.length)}% `;
                this.timelineTextMargin = this.getTimelineMargin(this.stepsItems.length);
                if (this.stepsItems.length > 5) {
                    this.stepsWidth = '119px';
                }
                this.eventsPanel.show(event);
                // if (this.stepsItems.length == 0) {
                //     // Bug 6522 for checking all the events core and non core and displaying the message specifically.
                //     this.trackingService.getEventsInfo(assignment.shipmentId).subscribe((res) => {
                //         if (res.containerDetails.length == 0) {
                //             this.noDataText = "No Data available";
                //         }
                //         else {
                //             this.noDataText = "Core milestone events are not available at this time.\n\nTo see if any other events are available please go to the Event tab on the Tracking Details page.";
                //         }
                //     })
                // }
            })
        )
    }

    getTimelineMargin(timelineLength) {
        let margin = '75%';
        switch (timelineLength) {
            case 1:
            case 2:
                margin = '75%'
                break;
            case 3:
            case 4:
                margin = '50%'
                break;
            case 5:
                margin = '25%'
                break;
            default:
                margin = '15%'
        }
        return margin;
    }


    restrictSelection(selectedColumnsDropdown) {
        event.preventDefault();
        event.stopPropagation();
        const columns = selectedColumnsDropdown.value;
        let state;
        switch (this.routeType) {
            case AirAppRoutes.User.TRACKING_LIST: {
                state = this.storageService.getItem('AirtrackingListState');
                state.columnOrder = [...this.selectedColumns].map(e => e.field)
                if (state) {
                    this.storageService.setItem('AirtrackingListState', state);
                    this.onTrackingListColumnreOrder(state);
                }
                break;
            }
            case AirAppRoutes.User.FAVORITE: {
                state = this.storageService.getItem('favoriteTableState');
                state.columnOrder = [...this.selectedColumns].map(e => e.field)
                if (state)
                    this.storageService.setItem('favoriteTableState', state);
                break;
            }
            default:
                return
        }

        if (columns.length < 15) {
            this.tableHeaders.map((element) => {
                element.isDisabled = false;
                element.isDefault = false;
                if (columns.some(col => col.field == element.field))
                    element.isDefault = true;
            })
        }
        else if (columns.length == 15) {
            this.tableHeaders.map((element) => {
                element.isDisabled = true;
                if (columns.some(col => col.field == element.field)) {
                    element.isDefault = true;
                    element.isDisabled = false;
                }
            })
        }
        else if (columns.length > 15) {
            this.tableHeaders.map(element => {
                element.isDefault = false;
                element.isDisabled = false;
                if (columns.some(col => col.field == element.field)) {
                    element.isDefault = true;
                }
            })
        }
        this.tableHeaders.map(e => {
            if (e.field == 'bdpReferenceNumber') { e.isDefault = true; e.isDisabled = true }
        })

        switch (this.routeType) {
            case AirAppRoutes.User.TRACKING_LIST: {
                this.storageService.setItem('AirtrackingColumnSettings', this.tableHeaders);
                break;
            }
            case AirAppRoutes.User.FAVORITE: {
                this.storageService.setItem('favoriteColumnSettings', this.tableHeaders);
                break;
            }
            // case AirAppRoutes.Manager.EXCEPTION: {
            //     this.storageService.setItem('exceptionColumnSettings', this.tableHeaders);
            //     break;
            // }
            default:
                break;
        }
    }

    dropdownOpen(selectedColumns: any) {
        if (selectedColumns.length == 15) {
            this.tableHeaders.map((element) => {
                element.isDisabled = true;
                if (selectedColumns.some(col => col.field == element.field)) {
                    element.isDefault = true;
                    element.isDisabled = false;
                }
            })
        }
        this.tableHeaders.map(e => {
            if (e.field == 'bdpReferenceNumber') { e.isDefault = true; e.isDisabled = true }
        })
    }


    // swap(a, b) {
    //     this.tableHeaders[a] = this.tableHeaders.splice(b, 1, this.tableHeaders[a])[0];
    // }
    // reOrderSelection(ev?: any) {
    //     let state;
    //     switch (this.routeType) {
    //         case AirAppRoutes.User.TRACKING_LIST: {
    //             state = this.storageService.getItem('AirtrackingListState').columnOrder;
    //             break;
    //         }
    //         case AirAppRoutes.User.FAVORITE: {
    //             state = this.storageService.getItem('favoriteTableState').columnOrder;
    //             break;
    //         }
    //         default:
    //             return
    //     }
    //     let temp = [];
    //     state.forEach(item => {
    //         let header = this.tableHeaders.find(col => col.field == item)
    //         let index = this.tableHeaders.indexOf(header)
    //         temp.push(index)
    //     })
    //     let sorted = [...temp].sort((a, b) => a - b);
    //     for (let i = 0; i < temp.length; i++) {
    //         if (temp[i] != sorted[i] && temp[i] > sorted[i])
    //             this.swap(temp[i], sorted[i])
    //     }
    // }

    private getColumnOrder() {
        let state;
        switch (this.routeType) {
            case AirAppRoutes.User.TRACKING_LIST: {
                state = this.storageService.getItem('AirtrackingListState')?.columnOrder;
                break;
            }
            // case AirAppRoutes.User.FAVORITE: {
            //     state = this.storageService.getItem('favoriteTableState')?.columnOrder;
            //     break;
            // }
            default:
                return
        }
        return state;
    }

    resetTable(event: any) {
        if (!this.isTrackingList) {
            const index = this.shipmentList.indexOf(event);
            this.shipmentList.splice(index, 1);
            this.removeData.emit(event);
        }
    }

    addFavoriteData(event: any) {
        if (!this.isTrackingList) {
            this.shipmentList.push(event);
            this.addData.emit(this.shipmentList)
        }
    }

    ngOnDestroy() {

        this.subscription.unsubscribe();
    }

    // 10434 Bug Fix
    resetTableFilters() {
        this.dataTable.reset();
    }

    // Search in tracking list table
    onInput(event: any) {
        const value = event.target.value.toLowerCase();
        this.dataTable.filterGlobal(value, 'contains');
    }
}
